import T from '../../common/traducao.js'
import { useFormikContext } from "formik";
import SelectControlValues from "./control-select-values.jsx";
import { useEffect, useState } from "react";

const PrecosScriptControl = (props) => {

    const constantes = T()

    const [precos, setPrecos] = useState();

    const {
        values,
        setFieldValue,
    } = useFormikContext();

    useEffect(() => {
        setPrecos(props?.values?.map((item, index) => {
            return {
                Id: index,
                PercentualComissao: item.PercentualComissao,
                Preco: item.Preco
            }
        }));

        const item = props?.values?.length > 0 && 
            (!values.ItemOrcamentoVenda.PrecoUnitario && !values.ItemOrcamentoVenda.PercentualComissao) ? props?.values[0] : null;

        item && setFieldValue("ItemOrcamentoVenda.PrecoUnitario", item.Preco);
        item && setFieldValue("ItemOrcamentoVenda.PercentualComissao", item.PercentualComissao)
        item && props.onChange && props.onChange(item);
    }, [])

    const colunas = [
        {
            key : "Preco",
            field: "Preco",
            fieldLabel: constantes.Preco
        },
        {   
            key : "PercentualComissao",
            field: "PercentualComissao",
            fieldLabel: constantes.PercComissao
        }
    ]

    return (
        <SelectControlValues {...props} name={props.name} 
            itens={precos} columns={colunas} onChange={(e) => {
                const index = Number(e.target.value);
                const item = Object.values(precos)[index];
                setFieldValue("ItemOrcamentoVenda.PrecoUnitario", item.Preco);
                setFieldValue("ItemOrcamentoVenda.PercentualComissao", item.PercentualComissao);
                props.onChange && props.onChange(item);
            }}
        />
    )
}

export default PrecosScriptControl;